import { convertStringToBigInt } from '@/utils';
import ProcessConfig from './ProcessConfig';

export default class ProcessConfigPayExemption extends ProcessConfig {
    
    constructor(data: any) {
        super(data);
        this.type = convertStringToBigInt(data.payExemptionType);
        this.filterMinimumValidType = BigInt(1);
    }

    public toServer() {
        // CON-451: se envía `active` para permitir el borrado lógico (botón ojo) desde el mantenimiento,
        // igual que ExamTypes. `payExemptionType` es nulo en los descuentos personalizados.
        return {
            id: this.id,
            payExemptionType: this.type,
            title: this.title,
            active: this.active
        };
    }
}
